import { LazyComponent, lazyWithNullFallback } from 'components/layout/util';

import { AnimationProps } from './types';

export const Animation: LazyComponent<AnimationProps> = lazyWithNullFallback(() =>
  import('./favorite-loading')
);
